(function () {
  function initSection(section) {
    var track = section.querySelector('.whoopea-toys-friends__track');
    var viewport = section.querySelector('.whoopea-toys-friends__viewport');
    var modal = section.querySelector('.whoopea-toys-friends__modal');
    var modalVideo = section.querySelector('.whoopea-toys-friends__modal-video');
    var autoplay = section.dataset.autoplay === 'true';
    if (!track || !viewport) return;

    if (!track.children.length && window.WHOOPEA_TOYS_FRIENDS_VIDEOS) {
      window.WHOOPEA_TOYS_FRIENDS_VIDEOS.forEach(function (item) {
        track.appendChild(createCard(section, item));
      });
    }

    bindCarouselDrag(viewport);
    bindModal(section, modal, modalVideo);

    if (autoplay) {
      observeVideos(section, viewport);
    } else {
      lazyLoadVideos(section);
    }
  }

  function createCard(section, item) {
    var article = document.createElement('article');
    article.className = 'whoopea-toys-friends__card';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'whoopea-toys-friends__card-button';
    button.dataset.videoSrc = item.short_video;
    button.dataset.videoTitle = item.title || '';
    button.setAttribute('aria-label', item.title || 'Play video');

    var media = document.createElement('span');
    media.className = 'whoopea-toys-friends__media';

    var video = document.createElement('video');
    video.className = 'whoopea-toys-friends__video';
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'metadata';
    video.dataset.src = item.short_video;
    if (item.thumbnail) video.poster = item.thumbnail;

    media.appendChild(video);
    button.appendChild(media);
    article.appendChild(button);
    return article;
  }

  function lazyLoadVideos(section) {
    section.querySelectorAll('.whoopea-toys-friends__video[data-src]').forEach(function (video) {
      if (!video.src) video.src = video.dataset.src;
    });
  }

  function observeVideos(section, viewport) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
            }
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      {
        root: viewport,
        threshold: 0.55,
      }
    );

    section.querySelectorAll('.whoopea-toys-friends__video').forEach(function (video) {
      observer.observe(video);
    });
  }

  function bindCarouselDrag(viewport) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    viewport.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      isDown = true;
      startX = event.pageX - viewport.offsetLeft;
      scrollLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });

    viewport.addEventListener('mouseleave', function () {
      isDown = false;
      viewport.classList.remove('is-dragging');
    });

    viewport.addEventListener('mouseup', function () {
      isDown = false;
      viewport.classList.remove('is-dragging');
    });

    viewport.addEventListener('mousemove', function (event) {
      if (!isDown) return;
      event.preventDefault();
      var x = event.pageX - viewport.offsetLeft;
      viewport.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  }

  function bindModal(section, modal, modalVideo) {
    if (!modal || !modalVideo) return;

    section.addEventListener('click', function (event) {
      var button = event.target.closest('.whoopea-toys-friends__card-button');
      if (!button) return;
      openModal(modal, modalVideo, button.dataset.videoSrc, button.dataset.videoTitle);
    });

    modal.querySelectorAll('[data-close-modal]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal(modal, modalVideo);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal(modal, modalVideo);
      }
    });
  }

  function openModal(modal, modalVideo, src, title) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('whoopea-toys-friends-modal-open');
    modalVideo.src = src;
    modalVideo.currentTime = 0;
    modalVideo.muted = false;
    modalVideo.setAttribute('aria-label', title || 'Video');
    modalVideo.play().catch(function () {});
  }

  function closeModal(modal, modalVideo) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('whoopea-toys-friends-modal-open');
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
  }

  function initAll() {
    document.querySelectorAll('.whoopea-toys-friends[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.whoopea-toys-friends[data-section-id]');
    if (section) initSection(section);
  });
})();
